'use strict';

import React from 'react';
import { Modal } from 'react-bootstrap';

require('styles//NewsItem.css');

class NewsItemComponent extends React.Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.createContentMarkup = this.createContentMarkup.bind(this);
    this.state = {
      showModal: false
    }
  }

  close() {
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  createContentMarkup() {
    return {__html: this.props.news.text};
  }

  render() {

    return (
      <div className="news-item-container">
        <div className="text">{this.props.news.title}</div>
        <a className="readmore"
          onClick={this.open}>
          Leia Mais
        </a>

        <Modal show={this.state.showModal} className="news-item" onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>
              <span className="title">Notícias | </span>
              {this.props.news.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div dangerouslySetInnerHTML={this.createContentMarkup()}>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

NewsItemComponent.displayName = 'NewsItemComponent';

// Uncomment properties you need
// NewsItemComponent.propTypes = {};
// NewsItemComponent.defaultProps = {};

export default NewsItemComponent;



// WEBPACK FOOTER //
// ./src/components/NewsItemComponent.js